import { hoyISO } from './fecha'

/**
 * Borradores de trabajo en curso guardados en ESTE navegador (sugerencia #102,
 * Diego Gorfinkiel, 20 oct 2026): una actualización de LGR (o un F5) no puede
 * borrar una asignación de salidas a medio armar.
 *
 * - Clave por usuario: `lgr_borrador_<nombre>_<usuarioId>`.
 * - Vencen al cambiar de día (hora argentina): no hay borradores viejos eternos.
 * - Todo acceso a localStorage va en try/catch: en una ventana privada o con
 *   el almacenamiento bloqueado la pantalla funciona igual, sin borrador.
 * - Es una red, no la fuente de verdad: al recuperar, cada pantalla valida
 *   contra lo que el backend dice que sigue disponible.
 */
const PREFIJO = 'lgr_borrador_'

export function claveBorrador(nombre, usuarioId) {
  return `${PREFIJO}${nombre}_${usuarioId ?? 'anon'}`
}

/** Saca los borradores de días anteriores (de cualquier usuario de este navegador). */
function limpiarVencidos() {
  try {
    const hoy = hoyISO()
    const claves = []
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      if (k && k.startsWith(PREFIJO)) claves.push(k)
    }
    claves.forEach(k => {
      let vencido = true
      try { vencido = JSON.parse(localStorage.getItem(k))?.dia !== hoy } catch { /* ilegible = vencido */ }
      if (vencido) localStorage.removeItem(k)
    })
  } catch { /* sin almacenamiento */ }
}

/** El borrador de hoy, o null. */
export function leerBorrador(clave) {
  limpiarVencidos()
  try {
    const raw = localStorage.getItem(clave)
    if (!raw) return null
    const b = JSON.parse(raw)
    return b && b.dia === hoyISO() ? b : null
  } catch {
    return null
  }
}

export function guardarBorrador(clave, usuario, datos) {
  try {
    localStorage.setItem(clave, JSON.stringify({
      ...datos,
      usuario_id: usuario?.id ?? null,
      usuario_nombre: usuario?.nombre ?? null,
      dia: hoyISO(),
      guardado_at: new Date().toISOString(),
    }))
  } catch { /* sin almacenamiento: se sigue sin borrador */ }
}

export function borrarBorrador(clave) {
  try { localStorage.removeItem(clave) } catch { /* sin almacenamiento */ }
}
